import { render, staticRenderFns } from "./SiteForm.vue?vue&type=template&id=c87c70b2&"
import script from "./SiteForm.vue?vue&type=script&lang=js&"
export * from "./SiteForm.vue?vue&type=script&lang=js&"
import style0 from "./SiteForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports